import dynamic from 'next/dynamic';
import { GroupSearchFormProps } from './GroupSearchForm.types';

export const GroupSearchFormDynamic = dynamic<{ model: GroupSearchFormProps }>(
  () => import('./GroupSearchForm').then(mod => mod.GroupSearchForm),
  { ssr: false }
);

export { GroupSearchForm } from './GroupSearchForm';
